/*
  文字定制项 · 推荐输入（配合 snippets/lf-text-ideas.liquid，做法照搬 Fil & Nous 的 fn-ps-skin.js）
  - 读产品元字段 liebefunk.text_ideas：每行「定制项标题 = 推荐1 | 推荐2」，标题按去掉变音符、大小写和必填星号后比较，
    完全相同优先，否则按开头匹配（例如写「Text unter」能对上「Text unter „Weihnachten“」）
  - 在 PatchStitch 文字输入框下面加一排「Ideen:」按钮，点一下填入；以「…」结尾的只填开头，光标停在末尾
  - PatchStitch 每次输入都会重建选项 DOM，所以用 MutationObserver 在绘制前重新处理
  - 饼干模板 assets/lf-biscuit-preview.js 也会加推荐按钮（.lf-bp-chips）：元字段写了的定制项以元字段为准，把那排去掉
*/
(function () {
  'use strict';
  var host = document.querySelector('[data-lf-text-ideas]');
  if (!host) return;

  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\*/g, '').replace(/\s+/g, ' ').trim(); }

  var ideas = [];
  var txt = ''; try { txt = JSON.parse(host.textContent) || ''; } catch (e) {}
  String(txt).split(/\n/).forEach(function (line) {
    var i = line.indexOf('='); if (i < 0) return;
    var k = norm(line.slice(0, i)), v = line.slice(i + 1).split('|').map(function (x) { return x.trim(); }).filter(Boolean);
    if (k && v.length) ideas.push([k, v]);
  });
  if (!ideas.length) return;

  function lookup(title) {
    var hit = null;
    ideas.forEach(function (e) { if (e[0] === title) hit = e[1]; });
    if (!hit) ideas.forEach(function (e) { if (!hit && title.indexOf(e[0]) === 0) hit = e[1]; });
    return hit;
  }
  /* 给饼干预览脚本用：这些定制项它就不再加自己的推荐按钮 */
  window.LfTextIdeas = { has: function (title) { return !!lookup(norm(title)); } };

  function apply() {
    var root = document.querySelector('[data-patchstitch-root]');
    if (!root) return;
    root.querySelectorAll('.ps-option').forEach(function (opt) {
      var ti = opt.querySelector('.ps-text-input'), t0 = opt.querySelector('.ps-option__title');
      if (!ti || !t0 || !t0.firstChild) return;
      var list = lookup(norm(t0.firstChild.textContent));
      if (!list) return;
      opt.querySelectorAll('.lf-bp-chips').forEach(function (x) { x.remove(); });
      var box = opt.querySelector('.lf-ideas');
      if (!box) {
        box = document.createElement('div'); box.className = 'lf-ideas';
        box.setAttribute('role', 'group'); box.setAttribute('aria-label', 'Ideen');
        var lb = document.createElement('span'); lb.className = 'lf-ideas__label'; lb.textContent = 'Ideen:'; box.appendChild(lb);
        list.forEach(function (s) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'lf-idea';
          b.textContent = s; b.setAttribute('data-lf-idea', s); box.appendChild(b);
        });
        (opt.querySelector('.ps-text-input-wrap') || ti).insertAdjacentElement('afterend', box);
      }
      var cur = norm(ti.value);
      box.querySelectorAll('.lf-idea').forEach(function (b) {
        var s = b.getAttribute('data-lf-idea'), on = String(!/…$/.test(s) && norm(s) === cur);
        if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.lf-idea'); if (!b) return;
    var opt = b.closest('.ps-option'), ti = opt && opt.querySelector('.ps-text-input'); if (!ti) return;
    var s = b.getAttribute('data-lf-idea'), prefix = /…$/.test(s);
    var v = prefix ? s.replace(/\s*…$/, ' ') : s;
    if (ti.maxLength > 0) v = v.slice(0, ti.maxLength);
    Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(ti, v);
    ti.dispatchEvent(new Event('input', { bubbles: true }));
    if (!prefix) return;
    /* PatchStitch 每次输入都会重建输入框，按 key 找到新的再聚焦 */
    var key = opt.getAttribute('data-ps-option-key');
    var fresh = (key && document.querySelector('.ps-option[data-ps-option-key="' + CSS.escape(key) + '"] .ps-text-input')) || ti;
    fresh.focus({ preventScroll: true }); fresh.setSelectionRange(fresh.value.length, fresh.value.length);
  });

  new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  apply();
})();
